import { ReactNode, forwardRef, useImperativeHandle, useState } from 'react'
import './index.scss'
import Block from '../Block';
import View from '../View';


export interface DrawerDialogRef {
    open: () => void,
    close: () => void,
}

export interface DrawerDialogProp {
    isModal?: boolean,
    direction?: 0 | 1 | 2 | 3,
    pannelWidthPercent?: number,
    zIndex?: number,
    children?: ReactNode,
    onVisibleChange?: (isOpen: boolean) => void
}


const DrawerDialog = forwardRef((prop: DrawerDialogProp, _ref) => {

    const { direction, pannelWidthPercent, zIndex } = prop;
    const [openState, setOpenState] = useState<number>(-1);

    const dDirection = direction || 0;

    /**
     * 打開
     */
    const _openBottomDialog = function () {
        setOpenState(1)
        if (prop.onVisibleChange) {
            prop.onVisibleChange(true)
        }
    }
    /**
     * 關閉
     */
    const _closeBottomDialog = function () {
        setOpenState(0)
        if (prop.onVisibleChange) {
            prop.onVisibleChange(false)
        }
        setTimeout(function () {
            setOpenState(-1)
        }, 250)
    }

    const _consumeTouchmove = () => { }

    useImperativeHandle(_ref, () => ({
        close: _closeBottomDialog,
        open: _openBottomDialog
    }))


    return <Block>
        {/*  弹窗MSK  */}
        <View
            className={
                'pannel-direction-' +
                dDirection +
                ' pannel-msk-state-' +
                (openState == -1 ? 'init' : openState != 0 ? 'open' : 'close')
            }
            style={{
                zIndex: `${zIndex || 999}`,
            }}
            onClick={()=>{
                if(!prop.isModal){
                    _closeBottomDialog()
                }
            }}
            onTouchMove={_consumeTouchmove}
        ></View>
        {/*  弹窗  */}
        <View
            className={
                'padding-safe-area pannel-direction-' +
                dDirection +
                ' pannel-content-state-' +
                (openState == -1 ? 'init' : openState != 0 ? 'open' : 'close')
            }
            onTouchMove={_consumeTouchmove}
            style={{
                ...(dDirection == 1 || dDirection == 3 ? {
                    width: pannelWidthPercent + "%"
                } : {}),
                zIndex: (zIndex || 999) + 1
            }}
        >
            {prop.children}
        </View>
    </Block>
})

export default DrawerDialog